<template>
  <div class="q-mt-lg">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      title="APROVADORES - Digite o nome, sap ou email para seleciona-lo
"
      selection="multiple"
      title-class="text-brand-5 text-weight-bold"
      v-model:selected="selected"
      dense
      v-model:pagination="pagination"
      class="q-mt-md"
      row-key="name"
      hide-pagination
      hide-header
      grid
    >
      <template v-slot:top-right>
        <q-input
          rounded
          v-model="filter"
          outlined
          dense
          debounce="300"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:item="props">
        <div
          class="q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition"
          :style="selected ? 'transform: scale(0.95);' : ''"
        >
          <q-card :class="selected ? 'bg-grey-2' : ''">
            <q-card-section class="row">
              <q-checkbox
                dense
                v-model="selected"
                :val="props.row"
                :label="props.row.name"
              />

              -

              {{ props.row.email }}
            </q-card-section>
            <q-separator />
          </q-card>
        </div>
      </template>
      <template #body-cell-epi="props">
        <q-td>
          <q-btn v-if="props" round color="positive" icon="headphones" />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

import { computed, onMounted, watch } from "vue";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
export default {
  setup(props, { emit }) {
    const quasar = useQuasar();
    const store = useStore();
    const selected = ref([]);
    const rows = ref([]);
    const disable = ref(true);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });
    const filter = ref("");

    const getSolicitantes = async (page = 1) => {
      try {
        const response = await store.dispatch("compras/getSolicitantes", {
          vendor_id: store.state.org.unidadeData.id,
          search: filter.value,
          page,
        });

        rows.value = response.data.results.data;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getSolicitantes);

    const handleRequest = async () => {
      getSolicitantes(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => selected.value,
      () => {
        emit("solicitante", selected.value);
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getSolicitantes();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );
    return {
      selected,
      rows,
      disable,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getSolicitantes,
      columns,
      filter,
    };
  },
};
</script>
